<script setup lang="ts">
const page = usePage().value;

const defaultIcons = ["Accommodation", "Compass", "Hiking Boot"];

const { data: siteIcons } = useLazyFetch<
  Array<{ iconName: string; iconSvg?: string }>
>("/api/site-icons", {
  key: "site-icons",
  server: false,
});

const filteredIcons = computed(() => {
  const icons = siteIcons.value;
  if (!icons?.length) return [];

  const pageHeroIcons = page?.heroIcons?.value
    ? page.heroIcons.value.split(",").map((icon: string) => icon.trim())
    : defaultIcons;

  return icons.filter((siteIcon) =>
    pageHeroIcons.includes(siteIcon.iconName),
  );
});
</script>
<template>
  <div class="brand-icons">
    <div
      v-for="icon in filteredIcons.slice(0, 3)"
      :key="icon.iconName"
      class="icon"
    >
      <div v-html="icon.iconSvg" />
    </div>
  </div>
</template>
